import api from '../config/api';

const sessionCache = new Map();

const keyFor = (google, location, category) =>
  `${google ? 'google' : 'osm'}:${String(location || '').toLowerCase()}:${category}`;

export const getPlacesCapabilities = async (tripId, requestConfig) => {
  const response = await api.get('/places/capabilities', {
    params: { tripId },
    ...requestConfig
  });
  return response.data;
};

export const fetchBrowsePlaces = async ({
  tripId,
  location,
  category,
  google = false,
  requestConfig
}) => {
  const cacheKey = keyFor(google, location, category);
  if (sessionCache.has(cacheKey)) {
    return sessionCache.get(cacheKey);
  }

  const path = google ? '/places/google-browse' : '/places/browse';
  const response = await api.get(path, {
    params: { tripId, location, category },
    ...requestConfig
  });
  const result = response.data || { places: [] };
  sessionCache.set(cacheKey, result);
  return result;
};

export const placePhotoUrl = (tripId, photoName, maxWidthPx = 400) => {
  if (!tripId || !photoName) return null;
  return `/places/photo?tripId=${encodeURIComponent(tripId)}&photoName=${encodeURIComponent(photoName)}&maxWidthPx=${maxWidthPx}`;
};
